import styled from 'styled-components';

export const Section = styled.section`
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 1.5rem;
    margin-bottom: 1.5rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
`;

export const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(${({ columns }) => columns || 1}, 1fr);
    gap: 1.25rem;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }
`;
